export const SUCCESS_INDICATOR_DURATION_MS = 3000
export const MAX_FILENAME_LENGTH = 200
export const MAX_UPLOAD_SIZE_BYTES = 2097152000 // 2 GB
